import { z } from 'zod';

/**
 * Make any field optional in the way a form box is optional: a blank box means "not
 * provided" and never reaches the payload, while anything typed is validated by the
 * schema exactly as before.
 *
 * `.optional()` alone is not that. It permits the key to be *absent*, but an untouched
 * text box or a "Choose…" select still submits `''`, which `z.email()` or `z.enum()`
 * rejects. This wraps the schema so `''` becomes `undefined` first. The registry tests
 * know to look through it (a select wrapped this way still has to wrap a `z.enum`).
 *
 * Used where a required attribute becomes optional in a particular form — most of all
 * an *update* form, where blank means "leave it as it is".
 */
export function blankMeansAbsent<S extends z.ZodType>(schema: S) {
  return z.union([z.literal('').transform(() => undefined), schema]).optional();
}

export type BlankMeansAbsent<S extends z.ZodType> = ReturnType<typeof blankMeansAbsent<S>>;
